const items = [
  {
    text: 'English',
    href: '/availability',
  },
  {
    text: 'Español',
    href: 'https://latino.dish.com/cobertura/',
    target: '_blank',
  },
]

export default items
